import { render, staticRenderFns } from "./petitionSearchBox.vue?vue&type=template&id=1d5765fc&scoped=true&"
import script from "./petitionSearchBox.vue?vue&type=script&lang=js&"
export * from "./petitionSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./petitionSearchBox.vue?vue&type=style&index=0&id=1d5765fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5765fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VList,VListItem,VListItemAvatar,VListItemContent})
